/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect } from 'react';

import classes from './styles.module.scss';
import whitePlayIcon from '../../../../assets/images/section-menu/play.svg';

export default function VideoPlayer({
  videoUrl,
  videoRef,
  isVideoPlaying,
  setIsVideoPlaying,
  startTime,
  endTime,
}) {
  const togglePlay = () => {
    if (videoRef.current) {
      if (!isVideoPlaying) {
        if (Math.round(videoRef.current.currentTime) >= Math.round(endTime)) {
          videoRef.current.currentTime = startTime;
        }

        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  // Sync video currentTime when trim boundaries change
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // If video is outside trim range, move it to start
    if (videoElement.currentTime < startTime || videoElement.currentTime > endTime) {
      videoElement.currentTime = startTime;
    }
  }, [videoRef, startTime, endTime]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) {
      return undefined;
    }

    // Sync state with video element play/pause events
    const handlePlay = () => {
      setIsVideoPlaying(true);
    };
    
    const handlePause = () => {
      setIsVideoPlaying(false);
    };

    // Enforce trim boundaries during playback
    const handleTimeUpdate = () => {
      // Clamp video time to trim range
      if (videoElement.currentTime < startTime) {
        videoElement.currentTime = startTime;
      }
      if (videoElement.currentTime > endTime) {
        videoElement.currentTime = endTime;
        videoElement.pause();
      }
    };

      videoElement.addEventListener('play', handlePlay);
      videoElement.addEventListener('pause', handlePause);
    videoElement.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      videoElement.removeEventListener('play', handlePlay);
      videoElement.removeEventListener('pause', handlePause);
      videoElement.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [videoRef, setIsVideoPlaying, startTime, endTime]);

  return (
    <div className={classes.VideoPlayer}>
      <div className={classes.videoContainer} onClick={togglePlay}>
        <video className={classes.video} src={videoUrl} ref={videoRef} />
        {!isVideoPlaying && (
          <img src={whitePlayIcon} alt="Play" className={classes.playIcon} />
        )}
      </div>
    </div>
  );
}
